import { render, staticRenderFns } from "./DashboardAGS.vue?vue&type=template&id=beea9100&scoped=true&"
import script from "./DashboardAGS.vue?vue&type=script&lang=js&"
export * from "./DashboardAGS.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAGS.vue?vue&type=style&index=0&id=beea9100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea9100",
  null
  
)

export default component.exports